var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const Diamond = (_a) => {
    var { color = "#42526E", size } = _a, props = __rest(_a, ["color", "size"]);
    return (React.createElement("svg", Object.assign({ width: size, height: size }, props, { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M23.7008 8.7L12.0008 23.1L0.300781 8.7L6.60078 1.5H17.4008L23.7008 8.7Z", fill: "#EC8BEE" }),
        React.createElement("path", { d: "M17.4008 1.5L23.7008 8.7H0.300781L6.60078 1.5H17.4008Z", fill: "#FD9FFF" }),
        React.createElement("path", { d: "M23.7 8.7L12 23.1V1.5H17.4L23.7 8.7Z", fill: "#C86DFF" }),
        React.createElement("path", { d: "M23.7 8.7H12V1.5H17.4L23.7 8.7Z", fill: "#D289FF" }),
        React.createElement("path", { d: "M0.299999 8.7L12 23.1L6 8.7L12 1.5H6.6L0.299999 8.7Z", fill: "#DA9DFF" }),
        React.createElement("path", { d: "M6.9 1.5L0.299999 8.7H6L12 1.5H6.9Z", fill: "#E5BBFF" }),
        React.createElement("path", { d: "M0.299999 8.7L12 23.1L2.4 8.7L8.7 1.5H6.6L0.299999 8.7Z", fill: "#E7C1FF" }),
        React.createElement("path", { d: "M6.59922 1.5L0.299218 8.7H2.39922L8.69922 1.5H6.59922Z", fill: "#EFD5FF" }),
        React.createElement("path", { d: "M23.7 8.7L12 23.1L18 8.7L12 1.5H17.4L23.7 8.7Z", fill: "#7233DA" }),
        React.createElement("path", { d: "M17.4 1.5L23.7 8.7H18L12 1.5H17.4Z", fill: "#8C4BF7" }),
        React.createElement("path", { d: "M23.7 8.7L12 23.1L21.6 8.7L15.3 1.5H17.4L23.7 8.7Z", fill: "#A653F9" }),
        React.createElement("path", { d: "M17.4008 1.5L23.7008 8.7H21.6008L15.3008 1.5H17.4008Z", fill: "#BB77FF" })));
};
//# sourceMappingURL=Diamond.js.map